import Header from "../../components/dashboard/header";
import {Breadcrumb, Button, Form, Input, message, Modal, Popconfirm, Select, Space, Spin} from "antd";
import {DashboardOutlined, DeleteOutlined, EditOutlined, PlusSquareOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {AiOutlineSetting} from "react-icons/ai";
import {TbFileSettings} from "react-icons/tb";
import UploadButton from "../../components/common/uploadButton";
import DataTable from "../../components/common/table";
import {useContext, useEffect, useRef, useState} from "react";
import {INFLOW, OUTFLOW} from "../../shared/flowType";
import {
    useCreateBudgetCategory, useDeleteBudgetCategory,
    useGetAllBudgetCategories,
    useUpdateBudgetCategory
} from "../../hooks/budgetCategory/budgetCategoryQuery";
import {extractValueFromInputRef, scrollToTop} from "../../helpers/dom";
import {MdOutlinePeopleOutline} from "react-icons/md";
import {
    useCreateDesignation, useDeleteDesignation,
    useGetAllDesignation,
    useUpdateDesignation
} from "../../hooks/designation/designationQuery";
import RefreshContext from "../../context/refreshContext";

const { Option } = Select
const eventBus = document


const categoryColumns = [
    {
        title:'S/N',
        dataIndex:'id',
        key:'id',
        render:(_,__,idx)=>idx+1
    },
    {
        title:"Title",
        dataIndex:"title",
        key:"title"
    },
    {
        title:'Value',
        dataIndex:'value',
        key:'value'
    },
    {
        title:'Action',
        key:'action',
        render:(_,item)=>(
            <EditDesignation category={item}/>
        )
    }
]

function EditDesignation({category: designation}){
    const titleRef = useRef(null)
    const valueRef = useRef(null)
    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [updating, setUpdating] = useState(false)
    const {flag, setFlag} = useContext(RefreshContext)

    const updateRecord = useUpdateDesignation()
    const deleteRecord = useDeleteDesignation()

    const showCreateModal = () => setIsOpen(true)
    const hideCreateModal = () => setIsOpen(false)

    const handleDelete = async () => {
        const d = await deleteRecord(designation.id)
        message.success("Deleted successfully")
        setFlag(!flag)
    }

    const handleSubmit = async () => {
        // create
        setUpdating(true)
        const data = await updateRecord(designation.id, {
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef)
        })

        message.success("item updated successfully")
        setUpdating(false)
        hideCreateModal()
        setFlag(!flag)
    }

    return (
        <>
            <Space size="small" wrap>
                <Button type="primary" onClick={showCreateModal}>
                    <EditOutlined />
                    Edit
                </Button>
                <Popconfirm
                    title="Delete this account type"
                    description="Are you sure to delete this designation?"
                    onConfirm={handleDelete}
                    onCancel={()=>null}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type="primary" danger>
                        <DeleteOutlined />
                        Delete
                    </Button>
                </Popconfirm>
            </Space>
            <Modal open={isOpen} footer={null} onCancel={hideCreateModal} title="Edit designation">
                <Form initialValues={{...designation}}>
                    <Form.Item name='title'>
                        <Input type="text" ref={titleRef} placeholder="Enter title"/>
                    </Form.Item>
                    <Form.Item name="value">
                        <Input type="text" ref={valueRef} placeholder="Enter value"/>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            span:8,
                            offset:20
                        }}
                        className="submit-button-wrapper"
                    >
                        <Button loading={updating} style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default function Designation(){

    const [isOpen, setIsOpen] = useState(false)
    const [creating, setCreating] = useState(false)
    const titleRef = useRef(null)
    const valueRef = useRef(null)
    const [edit, setEdit] = useState(null)
    const {flag, setFlag} = useContext(RefreshContext)

    const { loading, designations } = useGetAllDesignation(flag)

    const createRecord = useCreateDesignation()

    const showCreateModal = () => setIsOpen(true)
    const hideCreateModal = () => setIsOpen(false)


    const handleSubmit = async () => {
        // create
        setCreating(true)
        const data = await createRecord({
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef)
        })

        message.success("item added successfully")
        setCreating(false)
        hideCreateModal()
        setFlag(!flag)
    }

    useEffect(()=>{
        scrollToTop();
    },[]);


    return(
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>Dashboard</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <AiOutlineSetting/>
                                <Link to={"/dashboard"}>Configuration</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <MdOutlinePeopleOutline />
                                <Link to="/dashboard/designation">Designations</Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div style={{display:'flex',gap:'1em'}}>
                            <UploadButton/>
                            <Button style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={showCreateModal}>
                                <PlusSquareOutlined />
                                Add Designation
                            </Button>
                        </div>
                    </div>

                    <div className="table-section">
                        <Spin spinning={loading}>
                            <DataTable cols={categoryColumns} data={designations}/>
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal open={isOpen} title={'Add designation'} footer={null} onCancel={hideCreateModal}>
                <Form>
                    <Form.Item name='title'>
                        <Input type="text" ref={titleRef} placeholder="Enter title"/>
                    </Form.Item>
                    <Form.Item name="value">
                        <Input type="text" ref={valueRef} placeholder="Enter value"/>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            span:8,
                            offset:20
                        }}
                        className="submit-button-wrapper"
                    >
                        <Button loading={creating} style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                            Create
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}
